import { useApolloMutation } from '@/gql/apolloWrapper';
import useCurrentCompany from '@/hooks/useCurrentCompany';
import useNotifications from '@bambeehr/use-notifications';
import { useSelfUnenrollRetiredMutation } from '@/gql/generated';
import { ref } from '@nuxtjs/composition-api';
import useTrainingCatalog from '@/modules/Training/hooks/useTrainingCatalog/useTrainingCatalog';

const useSelfUnenrollRetired = () => {
  const { companyId } = useCurrentCompany();
  const { addSuccess, addError } = useNotifications();
  const isPending = ref(false);

  const selfUnenroll = (topicId: string, onComplete?: () => void) => {
    const { onDone, mutate, onError } = useApolloMutation(
      useSelfUnenrollRetiredMutation,
      { pending: isPending }
    );

    onDone(({ selfUnenrollRetired: res }) => {
      if (res?.errors?.length) {
        res.errors.forEach((err) => {
          addError(err || 'Failed to unenroll.');
        });

        return;
      }

      addSuccess('You have been unenrolled from this retired course.');

      const { refresh: refreshCatalog } = useTrainingCatalog();
      refreshCatalog();

      if (onComplete) {
        onComplete();
      }
    });

    onError((error) => {
      const err = error as any;
      const message =
        err?.graphQLErrors?.[0]?.message ||
        err?.message ||
        'Failed to unenroll. Please contact your administrator.';
      addError(message);
    });

    mutate({
      data: {
        companyId: companyId.value,
        topicId,
      },
    });
  };

  return { selfUnenroll, isPending };
};

export default useSelfUnenrollRetired;
